export const JAF_NAVI_TOP = 'https://jafnavi.jp/'

export const JAF_NAVI_TOP_TEST = 'https://test.jafnavi.jp/'

export const JAF_NAVI_DRIVE = 'https://drive.jafnavi.jp/'

export const JAF_NAVI_DRIVE_TEST = 'https://drive-dev.jafnavi.jp/'

export const JAF_NAVI_DRIVE_ST = 'https://drive-stg.jafnavi.jp/'

export const JAF_NAVI_EVENT = 'https://jafnavi.jp/qs/search_event.php'

export const JAF_NAVI_EVENT_TEST = 'https://test.jafnavi.jp/qs/search_event.php'

export const JAF_NAVI_PRESENT = 'https://jafnavi.jp/qs/search_present.php'

export const JAF_NAVI_PRESENT_TEST =
  'https://test.jafnavi.jp/qs/search_present.php'

export const JAF_NAVI_SHOPPING =
  'https://www.jaf.or.jp/jafnavi/shopping/index.php'

export const JAF_NAVI_SHOPPING_TEST =
  'https://ssl22875.mediagalaxy.ne.jp/jafnavi/shopping/index.php'

export const SSO_LOGIN = 'https://login.jaf.or.jp.frlogin'

export const SSO_LOGIN_TEST = 'https://login-stg.jaf.or.jp.frlogin'

export const JAF_NAVI_GUIDE = 'https://area.jaf.or.jp/guidance/benefits-notes'

export const JAF_NAVI_GUIDE_TEST =
  'https://staging.area.jaf.or.jp/guidance/benefits-notes'

export const JAF_NAVI_JOIN_GUIDE =
  'https://jaf.or.jp/individual/lp/ad/merit/?utm_source=jafnavi&utm_medium=link&utm_campaign=camp_join'

export const JAF_NAVI_JOIN_GUIDE_TEST =
  'https://staging.jaf.or.jp/individual/lp/ad/merit/?utm_source=jafnavi&utm_medium=link&utm_campaign=camp_join'


export const JAF_NAVI_FAQ = 'https://support.jaf.or.jp/?site_domain=default'

export const JAF_NAVI_FAQ_TEST = 'https://support.jaf.or.jp/?site_domain=default'

export const JAF_NAVI_SITEMAP =
  'https://area.jaf.or.jp/guidance/sitemap'

export const JAF_NAVI_SITEMAP_TEST =
  'https://area.jaf.or.jp/guidance/sitemap'

export const JAF_TOP = 'https://jaf.or.jp/'

export const JAF_TOP_TEST = 'https://staging.jaf.or.jp/'

export const JAF_NAVI_YUTAI_TOP = 'https://yutai.jafnavi.jp/?from_navigation=1'

export const JAF_NAVI_YUTAI_TOP_TEST = 'https://yutai-test.jafnavi.jp/?from_navigation=1'

// e-JAF予約
export const JAF_NAVI_YOYAKU = 'https://jafnavi.jp/jyyk/pa/#offer_list'

export const JAF_NAVI_YOYAKU_TEST = 'https://test.jafnavi.jp/jyyk/pa/#offer_list'

// マイページ
export const JAF_NAVI_MY_PAGE = 'https://mypage.jaf.or.jp'

export const JAF_NAVI_MY_PAGE_TEST = 'https://stg.mypage.jaf.or.jp'
